import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ew-payment-method-list',
  templateUrl: './payment-method-list.component.html',
  styleUrls: ['./payment-method-list.component.scss'],
})
export class PaymentMethodListComponent implements OnInit {
  @Input() showPrice: boolean = true;
  data: any[] = [
    {
      icon: 'fa-rocket-launch',
      img: 'https://www.freepnglogos.com/uploads/visa-and-mastercard-logo-26.png',
      name: 'Wire Transfer in CAD',
      price: '$315,074.00 MXN',
    },
    {
      icon: 'fa-credit-card-blank',
      img: 'https://www.freepnglogos.com/uploads/visa-and-mastercard-logo-26.png',
      name: 'Credit / Debit Card in USD',
      price: '$316,100.00 MXN',
    },
    {
      icon: 'fa-credit-card-blank',
      img: 'https://www.pngmart.com/files/5/American-Express-PNG-Image.png',
      name: 'American Express',
      price: '$318,200.00 MXN',
    },
    {
      icon: 'fa-wallet',
      img: 'https://www.freepnglogos.com/uploads/paypal-logo-png-8.png',
      name: 'Paypal',
      price: '$315,074.00 MXN',
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}
